import * as yup from 'yup';
import { Report } from 'types/report';
import { convertUTCToLocal } from 'utils/dateUtils';

export const initialValues = {
  site: '',
  reportType: '',
  name: '',
  month: '',
  year: '',
  endingInventoryCount: null,
  beginningInventoryCount: null,
  startDate: '',
  endDate: '',
  monthYear: '',
};

export const getInitialValues = (report: Report | null) => {
  if (!report) return initialValues;

  const monthYear =
    report.month && report.year
      ? `${report.month.toString().padStart(2, '0')}/${report.year}`
      : '';

  return {
    site: report.site?._id || '',
    reportType: report.reportType?.toString() || '',
    name: report.name || '',
    month: report.month?.toString() || '',
    year: report.year?.toString() || '',
    endingInventoryCount: report.endingInventoryCount || null,
    beginningInventoryCount: report.beginningInventoryCount || null,
    startDate: report.startDate
      ? convertUTCToLocal(report.startDate, true, true)
      : '',
    endDate: report.endDate
      ? convertUTCToLocal(report.endDate, true, true)
      : '',
    monthYear: monthYear,
  };
};

export const validationSchema = yup
  .object()
  .shape({
    site: yup.string().required('Site is required'),
    reportType: yup.string().required('Report Type is required'),
    name: yup.string().required('Report Name is required'),
    monthYear: yup.string().required('Month and Year is required'),
    beginningInventoryCount: yup.string().nullable(),
    endingInventoryCount: yup.string().nullable(),
    startDate: yup.string().required('Start date is required'),
    endDate: yup.string().required('End date is required'),
  })
  .test('date-range', 'End date must be after start date', function (value) {
    const { startDate, endDate } = value;
    if (!startDate || !endDate) return true;

    const start = new Date(startDate);
    const end = new Date(endDate);

    return end >= start;
  })
  .test(
    'inventory-counts',
    'Cannot select same inventory count',
    function (value) {
      const { beginningInventoryCount, endingInventoryCount } = value;

      if (!beginningInventoryCount || !endingInventoryCount) return true;

      return beginningInventoryCount !== endingInventoryCount;
    },
  );
